import { FC } from "react";

import styled from "@emotion/styled";

import AsyncContent from "../AsyncContent/AsyncContent";

const SkeletonList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const SkeletonCard = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
  background: var(--color-white, #fff);
  border-radius: 1.5rem;
  box-shadow: 0 5px 8px rgba(69, 49, 22, 0.08);
`;

const SkeletonBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

interface MealInsightSkeletonProps {
  count?: number;
}

const MealInsightSkeleton: FC<MealInsightSkeletonProps> = ({ count = 3 }) => (
  <SkeletonList>
    {Array.from({ length: count }, (_, i) => (
      <SkeletonCard key={i}>
        <AsyncContent check={[false]} width="2.75rem" height="2.75rem" />
        <SkeletonBody>
          <AsyncContent check={[false]} width="70%" height="1rem" />
          <AsyncContent check={[false]} width="40%" height="0.875rem" />
        </SkeletonBody>
      </SkeletonCard>
    ))}
  </SkeletonList>
);

export default MealInsightSkeleton;
